import { DisplayXSmall, ParagraphMedium } from 'baseui/typography'
import { useTranslation } from 'react-i18next'
import { personalizationTranslate } from '../i18n'

function ValidationSuccess() {
  const { t, i18n } = useTranslation()
  return (
    <div>
      <DisplayXSmall as="h1">{t('VALIDATION_SUCCESS')}</DisplayXSmall>
      <ParagraphMedium>{personalizationTranslate('elements.finished.signOkText1', i18n.language)}</ParagraphMedium>
      <ParagraphMedium>{t('THANKS')}</ParagraphMedium>
    </div>
  )
}

export default ValidationSuccess
